"use client";

import { usePathname } from "next/navigation";
import Link from "next/link";
import { Sidebar, SidebarContent, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@/shared/ui/sidebar";
import { useTranslations } from "next-intl";

export interface NavigationMenuItem {
  id: string;
  label: string;
  icon?: React.ComponentType;
  href: string;
}

interface NavigationSidebarProps {
  menuItems: NavigationMenuItem[];
  className?: string;
}

export function NavigationSidebar({ menuItems, className }: NavigationSidebarProps) {
  const pathname = usePathname();
  const t = useTranslations();

  const isActive = (href: string) => pathname === href;

  return (
    <Sidebar className={`bg-secondary-100 mt-[94px] w-fit border-none pt-20 pr-10 pl-80 ${className || ""}`}>
      <SidebarContent>
        <SidebarMenu className="gap-2">
          {menuItems.map((item) => (
            <SidebarMenuItem
              key={item.id}
              className={`w-[260px] rounded-[1000px] px-8 py-4 ${isActive(item.href) ? "bg-primary-600" : "bg-transparent"}`}
            >
              <SidebarMenuButton
                asChild
                isActive={isActive(item.href)}
                className="[&>span:last-child]:text-ellipsis-none h-auto p-0 [&>span:last-child]:overflow-visible [&>span:last-child]:break-words [&>span:last-child]:whitespace-normal"
              >
                <Link href={item.href}>
                  <span
                    className={`flex items-center ${item.icon ? "gap-4" : ""} ${isActive(item.href) ? "body-lg-bold text-white" : "body-lg-medium text-gray-400"}`}
                  >
                    {item.icon && <item.icon />}
                    {t(item.label)}
                  </span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarContent>
    </Sidebar>
  );
}
